export class BookingPayment{
    bookingId: number;
    command: {
        method: string;
        returnUrl: string;
    };
}


// WEBPACK FOOTER //
// ./src/holiday/models/BookingPayment.ts